import { render, staticRenderFns } from "./maxSvg.vue?vue&type=template&id=b0cfb80a&"
import script from "./maxSvg.vue?vue&type=script&lang=js&"
export * from "./maxSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports